module.exports = __webpack_public_path__ + "static/media/LogoAbu.ff157a14.png";